import React from 'react';
import Heading from 'js/components/Common/Heading/Heading';
import {OfferingsType} from '../ServicesOfferings';
import classes from './Content.module.pcss';
import parse from 'html-react-parser';


interface Props {
	offerings: Array<OfferingsType>,
	activeTab: number,
	activeSubTitle: string,
	activeSubTab: 'advisoryService' | 'managedService',
	subTabClickHandler: Function,
	eventCallback: Function,
	activeSubContent: Array<{listItem: string}>
}

const Content = (
	{offerings, activeSubTitle, activeTab, activeSubTab, activeSubContent, subTabClickHandler, eventCallback
	}: Props) => (
	<div className={classes.Content}>
		{offerings?.length > 0 ? <Heading text={offerings[activeTab]?.offeringTitle} type={'h4'} /> : ''}
		<div className={classes.SubTabs}>
			<div
				onClick={async () => {
					subTabClickHandler('advisoryService');
					await eventCallback('Advisory Service');
				}}
				className={`${activeSubTab === 'advisoryService' ? classes.Active : ''}`}>Advisory Service</div>
			<div
				onClick={async () => {
					subTabClickHandler('managedService');
					await eventCallback('Managed Service');
				}}
				className={`${activeSubTab === 'managedService' ? classes.Active : ''}`}>Managed Service</div>
		</div>
		<div className={classes.Wrap}>
			<div className={classes.Subtitle}>{activeSubTitle}</div>
			{activeSubContent?.length > 0 ?
				<div className={classes.InService}>
					<strong>In this Service</strong>
					<ul>
						{activeSubContent?.map((item, index) =>
							<li key={index}>{item.listItem}</li>)}
					</ul>
				</div> : ''}
			{offerings?.length > 0 && offerings[activeTab]?.aboutTheService?.length > 0 ?
				<div className={classes.About}>
					<strong>About the Service</strong>
					<div className={classes.AboutInfo}>{parse(offerings[activeTab]?.aboutTheService) || ''}</div>
				</div>
				: ''}
		</div>
	</div>
);

export default Content;
